<div class="wrap">


<div class="header">
  <div class="title">
    <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active" appChangeColorTheme attribute="color"></fa-icon>
    <h2>{{title}}</h2>
  </div>

  <div class="add_search_offer">
    <div class="add_offer"
      (click)="addOrEditResource('add')" appChangeColorTheme [isHover]="true">
      <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
      <span>Ajouter une ressource</span>
    </div>
    <div class="search_bar">
      <form [formGroup]="searchForm">
        <input type="text" placeholder="Chercher une ressource..." (input)="applyFilter($event.target.value)"
          formControlName="keyword">
      </form>

      <fa-icon [icon]="getFaIcon('faTimes')" (click)="resetSearch()" class="faTimes" *ngIf="valueInput"></fa-icon>
      <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="!valueInput"></fa-icon>

    </div>
  </div>
</div>

<app-admin-resource-club  [searchInput]="valueInput"></app-admin-resource-club>

  
</div>
